export const TABS = {
  AUCTION: 0,
  SALES: 1,
};

export const MY_BUYS_TABS = {
  MY_BUYS: 0,
  PAYMENTS: 1,
};
